import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { FeatureFlagsService } from '../services';

export const featureFlagGuard: CanActivateFn = route => {
  const featureFlagsService = inject(FeatureFlagsService);
  const router = inject(Router);
  const featureFlag = route.data['featureFlag'];

  if (featureFlag) {
    if (featureFlagsService.isOn(featureFlag)) {
      return true;
    } else {
      router.navigate(['/']);
      return false;
    }
  }
  return true;
};
